<template>
    <div class="flex flex-col items-center min-h-screen">
        <div class="flex flex-col items-center flex-1 w-full py-8">
            <div class="flex-grow mt-16">
                <header class="flex flex-col items-center flex-none max-w-2xl mx-auto mb-6">
                    <a class="focus:no-underline hover:no-underline" href="/budgets">
                        <logo-inverse size="lg"></logo-inverse>
                    </a>
                    <div class="px-16 mt-6 mb-2 font-medium text-center"></div>
                </header>
                <div class="max-w-2xl mx-auto">
                    <div class="lg:px-0 lg:py-0 flex flex-col items-center justify-center h-full px-4 py-10">
                        <h4 class="m-y-md md:w-1/2 w-full text-center">{{ $t('verify.heading') }}</h4>
                        <p class="md:w-2/3 w-full pb-6 text-center">{{ $t('verify.action_details') }}</p>
                        <div class="md:w-1/4 w-1/2 pb-10">
                            <svg-mail-sent></svg-mail-sent>
                        </div>
                        <div class="md:w-2/3 w-full">
                            <div class="border-warning-500 p-4 bg-gray-200 border-l-4 rounded shadow" role="alert">
                                <p class="mb-0" v-html="$t('verify.resend', { linkOpen: '<a class=&quot;ml-1 text-blue-500 redo&quot; href=&quot;/budgets/email/resend&quot;>', linkClose: '</a>' })"></p>
                            </div>
                        </div>
                        <p class="pt-12 text-center">
                            {{ $t('verify.logout_line') }}
                            <a @click="logout" class="text-blue-500" href="javascript:;">
                                {{ $t('auth.logout') }}
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <footer class="flex-none text-xs text-gray-700">
                <ul class="list-inline">
                    <li><a class="hover:text-blue-500 link-muted text-gray-700" href="/budgets">Prima pagină</a></li>
                    <li>|</li>
                    <li><a class="hover:text-blue-500 link-muted plain text-gray-700" href="/terms-and-conditions" target="_blank">Termene și condiții</a></li>
                    <li>|</li>
                    <li><a class="hover:text-blue-500 link-muted plain text-gray-700" href="/privacy-policy" target="_blank">Confidențialitate</a></li>
                    <li>|</li>
                    <li>{{ new Date().getFullYear() }} &copy; Reefkig Budgets</li>
                </ul>
            </footer>
        </div>
    </div>
</template>

<script>
import LogoInverse from '../../guest/budgets/partials/logo-inverse.vue';
import SvgMailSent from '../../svg/budgets/mail-sent.vue';

export default {
    components: {
        'logo-inverse': LogoInverse,
        'svg-mail-sent': SvgMailSent,
    },

    data() {
        return {
            form: new Form({}),
        };
    },

    methods: {
        logout() {
            Globals.post('/logout', this.form)
                .then(() => window.location.href = '/budgets')
                .catch(() => {});
        },
    },
};
</script>
